import axiosFactory from "../services/axios.factory";

// Logistiker- und Anlieferstellen-Logos kommen aus denselben Stammdaten wie am Desktop
// (CarrierInfo.vue / DestinationInfo.vue lesen sie aus dem Vuex-Store). Der Mobilbereich hat
// keinen eigenen Store-Zweig; die beiden Listen sind klein und aendern sich selten, deshalb
// hier einmal je Sitzung laden und im Modul halten.
let cache = null;

export async function loadMasterData() {
  if (cache) return cache;

  try {
    const [carriers, places] = await Promise.all([
      axiosFactory().get("/shipping_data/carrier_names"),
      axiosFactory().get("/shipping_data/container_arrival_places"),
    ]);
    cache = {
      carriers: (carriers.data && carriers.data.data) || [],
      places: (places.data && places.data.data) || [],
    };
  } catch (e) {
    // Ohne Logos bleibt die Anzeige benutzbar — es greifen die Ersatzsymbole.
    cache = { carriers: [], places: [] };
  }

  return cache;
}

export function carrierLogo(data, carrierNameId) {
  const c = (data.carriers || []).find((x) => x.id === carrierNameId);
  return (c && c.logo) || null;
}

export function placeLogo(data, placeId) {
  const p = (data.places || []).find((x) => x.id === placeId);
  return (p && p.logo) || null;
}
